import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../application/services/auth.service';

// Guard que protege las rutas que requieren sesion iniciada.
// Si el token no existe o ya expiro, redirige al login automaticamente.
export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.hasValidToken()) {
    return true;
  }

  router.navigate(['/auth/login']);
  return false;
};
